var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInputEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.667,
    height: 18.501,
    viewBox: "0 0 18.667 18.501",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-edit",
    "data-name": "Icon feather-edit",
    transform: "translate(-2 -1.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12103",
    "data-name": "Path 12103",
    d: "M10.381,6H4.64A1.64,1.64,0,0,0,3,7.64V19.122a1.64,1.64,0,0,0,1.64,1.64H16.122a1.64,1.64,0,0,0,1.64-1.64V13.381",
    transform: "translate(0 -1.442)",
    fill: "none",
    stroke: "#5dadae",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12104",
    "data-name": "Path 12104",
    d: "M20.611,3.328a1.74,1.74,0,1,1,2.46,2.46L15.28,13.579,12,14.4l.82-3.28Z",
    transform: "translate(-4.079)",
    fill: "none",
    stroke: "#5dadae",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputEdit);
export default __webpack_public_path__ + "static/media/input-edit.6a74851e7a14008e994246a14c4b509d.svg";
export { ForwardRef as ReactComponent };